export const nativeShare = async (shareData) => {
    try {
        await navigator.share(shareData);
        return true;
    }
    catch {
        return false;
    }
};
